<script setup>
    import { useMainStore } from '@/stores/store.js';
    import { PhAsterisk } from '@phosphor-icons/vue';
    import { Validations } from '@/validations.js';
    import RoomDataForm from './RoomDataForm.vue';
    const store = useMainStore();
</script>
<!--
ROOM STEP
-->
<template>
    <div
        id="step-room"
        class="lux-step-root">
        <h2 class="lux-page-title">Room Dimensions and Acoustics</h2>
        <p class="lux-copy-normal">
            Please provide the dimensions of your room and select any existing acoustic materials. Then select the intended use and room function to
            help us calculate the recommended reverberation times.
        </p>

        <div class="lux-form lux-mt w-full bg-white px-4 py-6 text-black sm:px-12 sm:py-10">
            <RoomDataForm :realtime="true" />
            <div class="mt-10 text-center">
                <button
                    type="button"
                    class="lux-btn lux-btn-small lux-btn-bare font-normal"
                    @click="store.handleClearData(store.user.currentStepName)">
                    Clear Form
                </button>
            </div>
        </div>
        <span class="hidden">
            <input
                type="hidden"
                name="stepRoomValid"
                :value="store.stepRoomIsValid"
                class="hidden" />
        </span>
    </div>
</template>
